<template>
    <div class="admin-page">
        <div class="tiles">
            <router-link v-if="userIsZorgProfessional" :to="{ name: $routeName.ADMIN_CLIENTS }" class="tile is-client">
                Cliënten<br> Beheren
            </router-link>
            <router-link v-if="userIsBeheerder" :to="{ name: $routeName.ADMIN_SMARTWATCHES }" class="tile is-smartwatch">
                Smartwatches<br> Beheren
            </router-link>
            <router-link v-if="userIsBeheerder" :to="{ name: $routeName.ADMIN_LOCATIONS }" class="tile is-location">
                Woonlocaties<br> Beheren
            </router-link>
            <router-link v-if="userIsBeheerder" :to="{ name: $routeName.ADMIN_EMPLOYEES }" class="tile is-client">
                Zorg Professionals<br> Beheren
            </router-link>
          <router-link v-if="userIsBeheerder" :to="{ name: $routeName.ADMIN_MELDKAMER_SETTINGS }" class="tile is-settings">
            Meldkamer <br> instellingen
          </router-link>
        </div>
    </div>
</template>

<script>
import { Role } from '../../utils/enums';
export default {
    name: 'admin-page',
    computed: {
        userIsZorgProfessional() {
            return this.$store.getters.getUserGroups.includes(Role.ZORG_PROFESSIONAL);
        },
        userIsBeheerder() {
            return this.$store.getters.getUserGroups.includes(Role.MILES_BEHEERDER);
        }
    }
};
</script>

<style scoped lang="scss">
    .tiles {
        display: flex;
        flex-wrap: wrap;
        background-color: $white;
        box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        overflow: hidden;

        @include desktop {
            background-color: transparent;
            box-shadow: none;
            border-radius: 0;
        }
    }
    .tile {
        width: 50%;
        height: 108px;
        font-size: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $gray-dark;
        text-align: center;
        padding-top: 30px;
        background-position-y: 20px;
        transition: all 0.3s ease;

        @include desktop {
            width: 14rem;
            height: 140px;
            background-color: $white;
            box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            font-size: 1rem;
            margin-bottom: 2rem;
            margin-right: 2rem;

            &:last-child {
                margin-right: 0;
            }
        }

        &:active,
        &:hover {
            background-color: $primary;
            color: $white;

            &.is-smartwatch {
                background-image: url('../../assets/icons/watch-white.svg');
            }
            &.is-client {
                background-image: url('../../assets/icons/profile-white.svg');
            }
            &.is-location {
                background-image: url('../../assets/icons/building-white.svg');
            }
          &.is-settings{
            background-image: url('../../assets/icons/settings-white.svg');
          }
        }

        &.is-smartwatch {
            background-image: url('../../assets/icons/watch-blue.svg');
        }
        &.is-client {
            background-image: url('../../assets/icons/profile-blue.svg');
        }
        &.is-location {
            background-image: url('../../assets/icons/building-blue.svg');
        }
      &.is-settings{
        background-image: url('../../assets/icons/settings-blue.svg');
      }
    }
</style>
